import React from "react";
import styled from "styled-components";
import { Text } from "@lmn/design-system";
import TravelDates from "@/components/UI/TravelDates/TravelDates";
import IconPlaneNe from "@lmn/lastminute-react-icons/icons-converted/lastminute-icons-solid/IconPlaneNe.js";
import TourOperatorLogo from "@/components/UI/TourOperatorLogo/TourOperatorLogo";
import HoverToolTip from "@/components/UI/Tooltip/HooverTooltip";
import TourOperator from "@/lib/Types/TourOperator";
import { BookingInfo } from "@/lib/Types/DateListResponse/BookingInfo";
import { useScreenSize } from "@/lib/Hooks/useScreenSize";

const StyledHeader = styled.div<{ $isAvailable?: boolean }>(
  ({ theme, $isAvailable }) => ({
    color: $isAvailable
      ? theme.kallisto.color.text.static.textInverse
      : theme.kallisto.color.text.static.textPrimary,

    p: {
      color: $isAvailable
        ? theme.kallisto.color.text.static.textInverse
        : theme.kallisto.color.text.static.textPrimary,
    },

    backgroundColor: $isAvailable
      ? theme.kallisto.color.background.static.backgroundNeutralContrast
      : theme.kallisto.color.background.static.backgroundLayer01,

    borderBottom: `1px solid ${theme.kallisto.color.border.static.borderNeutral}`,
    padding: theme.kallisto.space.space100,
    display: "flex",
    alignItems: "center",
    gap: "8px",
  })
);

const DepartingAirport = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));

const TourOperatorLogoContainer = styled.div(({ theme }) => ({
  marginLeft: "auto",
  backgroundColor: theme.kallisto.color.background.static.backgroundLayer01,
  padding: "4px",
  borderRadius: theme.kallisto.border.radius.radius50,
}));

interface OfferHeaderProps {
  from: string;
  to: string;
  duration: number;
  stayDuration: number;
  departureAirportCode?: string;
  tourOperator: TourOperator;
  isAvailable: boolean;
  bookingInfo: BookingInfo;
  isDebugMode: boolean;
  source: string;
}

const OfferHeader: React.FC<OfferHeaderProps> = ({
  from,
  to,
  duration,
  stayDuration,
  departureAirportCode,
  tourOperator,
  isAvailable,
  bookingInfo,
  isDebugMode,
  source,
}) => {
  const { isMobile } = useScreenSize();
  return (
    <StyledHeader $isAvailable={isAvailable}>
      <TravelDates from={from} to={to} duration={duration} stayDuration={stayDuration} transparentBg />
      {!!departureAirportCode && (
        <DepartingAirport>
          <Text variant="BodySmall" weight="regular">
            ·
          </Text>
          <IconPlaneNe size={18} />
          <Text variant="BodySmall" weight="regular">
            {departureAirportCode}
          </Text>
        </DepartingAirport>
      )}
      {isDebugMode && (
        <Text
          variant="Caption"
          forceTag="span"
          weight="bold"
          margin={{ left: "auto" }}
          color="textPrimaryDefault"
        >
          {source}
        </Text>
      )}

      <TourOperatorLogoContainer>
        <HoverToolTip
          content={tourOperator.name}
          trigger={
            <TourOperatorLogo
              tourOperator={tourOperator}
              width={isMobile ? 42 : 50}
              height={isMobile ? 16 : 20}
            />
          }
        />
      </TourOperatorLogoContainer>
    </StyledHeader>
  );
};

export default OfferHeader;
